"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("form", [_c("SelectCostumer", {
    attrs: {
      "default-selected": _vm.form.client
    },
    on: {
      onSelect: _vm.costumerSelect
    }
  }), _vm._v(" "), _c("SelectPlot", {
    attrs: {
      "default-selected": _vm.form.plot,
      "default-selected-subplot": _vm.form.subPlot
    },
    on: {
      onSelect: _vm.plotSelect,
      onSelectSubplot: _vm.subplotSelect
    }
  }), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Placa do Veículo",
      expanded: ""
    }
  }, [_c("app-input", {
    attrs: {
      placeholder: "Informe a placa do veículo"
    },
    model: {
      value: _vm.form.plate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "plate", $$v);
      },
      expression: "form.plate"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Quantidade de pallets",
      expanded: ""
    }
  }, [_c("money", _vm._b({
    staticClass: "input",
    attrs: {
      placeholder: "Informe o valor de pallets",
      type: "text",
      id: "uname",
      expanded: ""
    },
    model: {
      value: _vm.form.pallets,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "pallets", $$v);
      },
      expression: "form.pallets"
    }
  }, "money", _vm.money_integer, false))], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [_c("b-field", {
    attrs: {
      label: "Data da Colheita"
    }
  }, [_c("b-datepicker", {
    attrs: {
      "show-week-number": true,
      locale: "pt_bR",
      placeholder: "Clique para selecionar...",
      icon: "calendar-today",
      "icon-right": _vm.form.harvestDate ? "close-circle" : "",
      "icon-right-clickable": "",
      "trap-focus": ""
    },
    model: {
      value: _vm.form.harvestDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "harvestDate", $$v);
      },
      expression: "form.harvestDate"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Data de venda"
    }
  }, [_c("b-datepicker", {
    attrs: {
      "show-week-number": true,
      locale: "pt_bR",
      placeholder: "Clique para selecionar...",
      icon: "calendar-today",
      "icon-right": _vm.form.date ? "close-circle" : "",
      "icon-right-clickable": "",
      "trap-focus": ""
    },
    model: {
      value: _vm.form.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "date", $$v);
      },
      expression: "form.date"
    }
  })], 1)], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [_c("app-select", {
    attrs: {
      label: "Tipo de pagamento",
      placeholder: "Tipo de pagamento",
      items: _vm.listTypesPayments,
      option: "id",
      "name-item": "name",
      expanded: ""
    },
    model: {
      value: _vm.form.paymentConditions,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "paymentConditions", $$v);
      },
      expression: "form.paymentConditions"
    }
  })], 1), _vm._v(" "), _c("SelectProduct", {
    ref: "selectProducts",
    attrs: {
      "default-products": _vm.form.products
    },
    on: {
      onUpdate: _vm.updateProducts
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "btn-submit"
  }, [_c("b-button", {
    staticClass: "btn",
    attrs: {
      extended: ""
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v("\n      Concluir\n    ")])], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;